import type { BoxProps } from '@hover/blueprint';
import { Body, Box, Image, Logo } from '@hover/blueprint';
import React from 'react';

import { getPartnerConfiguration } from 'src/modules/homeownerApp/helpers/partners';
import { usePartnerCobrandingWithCustomLogo } from 'src/modules/homeownerApp/hooks/usePartner';
import { CustomIcon } from 'src/shared/components';

import { LOGO_FILTER, VerticalDivider, getFilterForLogo } from './utils';

interface CobrandLogoProps extends BoxProps {
  background?: string;
  cobrandName?: string;
  cobrandLogo?: string;
  cobrandId?: number;
  hideHoverMark?: boolean;
  theme?: 'light' | 'dark';
}

const CobrandLogo = ({
  background,
  cobrandName,
  cobrandLogo,
  cobrandId,
  hideHoverMark,
  theme = 'dark',
  ...props
}: CobrandLogoProps) => {
  const partner = getPartnerConfiguration(cobrandId);
  const filter = getFilterForLogo(cobrandLogo, partner);

  const customLogo = usePartnerCobrandingWithCustomLogo(
    partner ?? undefined,
    theme,
  );

  return (
    <Box
      alignItems="center"
      justifyContent="flex-start"
      w="100%"
      zIndex={1}
      {...props}
    >
      <Logo
        colorMode={background ? 'dark' : 'light'}
        display={hideHoverMark ? 'none' : 'block'}
        height={200}
        variant="symbol"
      />
      {(cobrandName || cobrandLogo) && !hideHoverMark && (
        <VerticalDivider height="22px" mx={200} />
      )}
      {filter === LOGO_FILTER.TEXT && (
        <Body
          color={background ? 'neutral.100' : 'neutral.900'}
          margin="0 !important"
        >
          {cobrandName}
        </Body>
      )}
      {filter === LOGO_FILTER.TRANSPARENT && (
        <Image alt="cobrand logo" height={200} src={cobrandLogo} />
      )}
      {filter === LOGO_FILTER.PILL && (
        <Box
          backgroundColor="neutral.100"
          borderRadius={200}
          height="22px"
          justifyContent="center"
          ml={100}
          objectFit="cover"
          p={100}
        >
          <Image
            alt="cobrand logo"
            display="block"
            height="100%"
            src={cobrandLogo}
            width="auto"
          />
        </Box>
      )}
      {filter === LOGO_FILTER.CUSTOM && customLogo && (
        <CustomIcon
          icon={customLogo}
          iconHeight="116px"
          iconWidth="200px"
          ml="-82px"
          transform="scale(0.2)"
        />
      )}
    </Box>
  );
};

export { CobrandLogo };
